import { Pipe, PipeTransform } from '@angular/core';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';

dayjs.extend(relativeTime);

/**
 * Renders an ISO timestamp as a short, locale-aware string suitable for a
 * "Last updated" column. Anything within ~30 days produces a relative
 * phrase ("vor 2 Stunden", "vor 3 Tagen") via dayjs's relativeTime plugin;
 * anything older falls back to an absolute DD.MM.YYYY date. Empty input
 * returns an empty string so the column collapses gracefully.
 */
@Pipe({ name: 'relativeTime', standalone: true })
export class RelativeTimePipe implements PipeTransform {
  transform(value: string | null | undefined): string {
    if (!value) return '';
    const date = dayjs(value);
    if (!date.isValid()) return '';

    const ageInDays = dayjs().diff(date, 'day');
    if (ageInDays < 30) {
      return date.fromNow();
    }
    return date.format('DD.MM.YYYY');
  }
}
